<template>
  <div
    class="profile-container"
    :class="{ open: showDropdown }"
    @mouseleave="() => toggleDropdown(false)"
  >
    <span class="avatar"><span class="af af-account"></span></span>
    <span class="name">{{ name }}</span>
    <span v-if="hasActions" class="dropdown-trigger" @mouseenter="() => toggleDropdown(true)"
      ><span class="af af-chevron-down"></span
    ></span>
    <div v-if="hasActions" class="dropdown-actions" :class="{ open: showDropdown }">
      <ul>
        <li @click="onLogout">Logout</li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Profile',
  props: {
    name: String,
    hasActions: Boolean,
  },
  emits: ['logout'],
  setup(props, { emit }) {
    const showDropdown = ref<boolean>(false);

    const toggleDropdown = (show: boolean) => {
      showDropdown.value = show;
    };

    const onLogout = () => emit('logout');

    return { showDropdown, toggleDropdown, onLogout };
  },
});
</script>

<style lang="scss">
.profile-container {
  display: flex;
  align-items: center;
  border: 1px solid var(--grey-light);
  border-radius: 4px;
  padding: var(--space-1);
  position: relative;
  transition: all 0.25s;
  background-color: white;

  .avatar {
    width: 28px;
    height: 28px;
    background-color: var(--grey-light);
    border-radius: 50%;
    text-align: center;
    vertical-align: bottom;
    color: var(--grey-ultra-light);
    font-size: var(--font-size-20);
    line-height: 1.5;
  }

  .name {
    margin: 0 var(--space-2);
    font-size: var(--font-size-14);
  }

  &.open {
    border-radius: 4px 4px 0 0;
  }

  .dropdown-trigger {
    cursor: pointer;
    margin-right: var(--space-1);
    font-size: var(--font-size-12);
  }

  .dropdown-actions {
    position: absolute;
    width: 100%;
    top: 100%;
    left: -1px;
    border: 0;
    border-radius: 0 0 4px 4px;
    background-color: white;
    max-height: 0;
    overflow-y: hidden;
    opacity: 0;
    transition: all 0.25s;

    ul {
      padding: var(--space-2);
      font-size: var(--font-size-14);

      li {
        text-align: right;
        cursor: pointer;

        &:hover {
          color: var(--coral);
        }
      }
    }

    &.open {
      opacity: 1;
      max-height: 300px;
      border: 1px solid var(--grey-light);
    }
  }
}
</style>
